export interface ConceptDef {
    name: string;
    label: string;
    description?: string;
    isFixed?: boolean;
    isFixedUSD?: boolean;
    percentage?: number;
}

export interface ConceptSection {
    title: string;
    concepts: ConceptDef[];
}

export const COP_CONSTANTS = {
    LIFE_INSURANCE: 63166,
    PREPAID_MEDICINE: 234570
};

export const USD_CONSTANTS = {
    LAPTOP_RENTAL: 60, // USD
    DELIVERY_SUPPORT: 50 // USD
};

export const DEFAULT_RATES: Record<string, number> = {
    // Salario Base
    'Connectivity assistance': 0,

    // Prestaciones Sociales
    'Unemployment Fund': 0.0833,
    'Interest Unemployment Fund': 0.01,
    'Salary 13': 0.0833,
    Vacation: 0.0417,

    // Seguridad Social
    'Health System': 0.085,
    'Retirement Fund': 0.12,
    'Labor Risk Insurance': 0.00522,

    // Parafiscales
    'Contribucions by employer (Caja de compensacion Familiar)': 0.04,
    'Contribucions by employer (Sena)': 0.02,
    'Contribucions by employer (Icbf)': 0.03,

    // Otros Beneficios
    Severance: 1 / 12,
    'Life insurance': COP_CONSTANTS.LIFE_INSURANCE,
    'Medicina Prepagada': COP_CONSTANTS.PREPAID_MEDICINE,

    // Costos Operativos
    Hiring: 0,
    'Safety Study': 0,
    'Laptop Rental': 0,
    'Delivery support cost': 0,

    // Costos Administrativos
    Financing: 0,
    'Management Fees': 0
};

export const CONCEPT_SECTIONS: ConceptSection[] = [
    {
        title: 'Salario Base',
        concepts: [
            { name: 'Salary', label: 'Salary' },
            { name: 'Connectivity assistance', label: 'Connectivity assistance', isFixed: true }
        ]
    },
    {
        title: 'Prestaciones Sociales',
        concepts: [
            { name: 'Unemployment Fund', label: 'Unemployment Fund' },
            { name: 'Interest Unemployment Fund', label: 'Interest Unemployment Fund' },
            { name: 'Vacation', label: 'Vacation' },
            { name: 'Salary 13', label: 'Salary 13' }
        ]
    },
    {
        title: 'Seguridad Social',
        concepts: [
            { name: 'Health System', label: 'Health System' },
            { name: 'Retirement Fund', label: 'Retirement Fund' },
            { name: 'Labor Risk Insurance', label: 'Labor Risk Insurance' }
        ]
    },
    {
        title: 'Parafiscales',
        concepts: [
            { name: 'Contribucions by employer (Caja de compensacion Familiar)', label: 'Contribucions by employer (Caja de compensacion Familiar)' },
            { name: 'Contribucions by employer (Sena)', label: 'Contribucions by employer (Sena)' },
            { name: 'Contribucions by employer (Icbf)', label: 'Contribucions by employer (Icbf)' }
        ]
    },
    {
        title: 'Otros Beneficios',
        concepts: [
            { name: 'Severance', label: 'Severance' },
            { name: 'Life insurance', label: 'Life insurance', isFixed: true },
            { name: 'Medicina Prepagada', label: 'Medicina Prepagada', isFixed: true }
        ]
    },
    {
        title: 'Costos Operativos',
        concepts: [
            { name: 'Hiring', label: 'Hiring', isFixedUSD: true },
            { name: 'Safety Study', label: 'Safety Study', isFixedUSD: true },
            { name: 'Laptop Rental', label: 'Laptop Rental', isFixedUSD: true },
            { name: 'Delivery support cost', label: 'Delivery support cost' }
        ]
    },
    {
        title: 'Costos Administrativos',
        concepts: [
            { name: 'Financing', label: 'Financing' },
            { name: 'G&A Colombia', label: 'G&A Colombia' },
            { name: 'Management Fees', label: 'Management Fees' }
        ]
    }
];

export const DEFAULT_CONFIG = {
    smmlv: 1423500,
    exchangeRate: 4100,
    gaPercentage: 10,
    highSalaryMultiplier: 10,
    integralMultiplier: 13,
    operationalCosts: {
        hiring: 0,
        safetyStudy: 0,
        laptopRental: 0,
        deliverySupport: 0
    }
};

export const CALCULATION_CONSTANTS = {
    INTEGRAL_THRESHOLD_MULTIPLIER: 13,
    INTEGRAL_CALCULATION_BASE: 0.7,
    HIGH_SALARY_MULTIPLIER: 10,

    // Rates
    CESANTIAS_RATE: 0.0833,
    INTERESES_CESANTIAS_RATE: 0.01,
    PRIMA_RATE: 0.0833,
    VACACIONES_RATE: 0.0417,
    SALUD_RATE: 0.085,
    PENSION_RATE: 0.12,
    CAJA_COMPENSACION_RATE: 0.04,
    SENA_RATE: 0.02,
    ICBF_RATE: 0.03,
    SEVERANCE_INTEGRAL_RATE: 0.0516,

    // Fixed Values
    SEGURO_VIDA: COP_CONSTANTS.LIFE_INSURANCE,
    MEDICINA_PREPAGADA: COP_CONSTANTS.PREPAID_MEDICINE
};

export const DEFAULT_RATES_BY_TYPE = {
    ordinario_inf: { ...DEFAULT_RATES },
    ordinario_sup: { ...DEFAULT_RATES },
    integral: {
        ...DEFAULT_RATES,
        'Unemployment Fund': 0,
        'Interest Unemployment Fund': 0,
        'Salary 13': 0,
        Vacation: 0.0417,
        Severance: 0.0516
    }
};
